import { LIMPAR_VEICULO_ITINERARIO_SELECIONADO } from '../types'

export default function limparVeiculoItinerarioSelecionado () {
  return {
    type: LIMPAR_VEICULO_ITINERARIO_SELECIONADO
  }
}
